import { AcompanhamentoAPI } from '@/api/acompanhamento.api';
import { AxiosObservable } from 'axios-observable';

const api = new AcompanhamentoAPI();

const list = (params: any): AxiosObservable<any> => {
  return api.list(params);
};

export default {
  list
}
